import { Controller } from '@hotwired/stimulus'
import $ from 'jquery'
import 'bootstrap-datepicker'
import {
  generatePresignedUrl,
  uploadFileInForm,
  areAllFilesUploaded,
} from '../../modules/s3_uploader'
import { loadPhoneInput, validateInput } from '../../modules/phone_input'
import { runPrefill } from '../../../shared/registration_doc_prefill'

export default class extends Controller {
  static targets = [
    'phoneInput',
    'validMsg',
    'errorMsg',
    'kycForm',
    'businessRegistrationInput',
    'directorUtilityBillInput',
    'businessProfileInput',
    'parseStatus',
  ]

  static values = {
    parseUrl: String,
    documentName: { type: String, default: 'registration document' },
    parseMessages: Object,
  }


  connect() {
    window.addEventListener('load', () => this._loadPhoneInput())

    this._loadPhoneInput()
    this._handleGeneratePresignedUrl()
    this._handleFileUploadSize()

    $('.datepicker').datepicker({
      format: 'dd/mm/yyyy',
      autoclose: true,
    })

    if (this.hasKycFormTarget) {
      this.kycFormTarget.addEventListener('submit', this.submitForm.bind(this))
    }
  }

  _handleGeneratePresignedUrl() {
    // Not every variant renders all upload fields (e.g. the SG form drops the
    // business-registration / utility-bill uploads).
    if (this.hasBusinessRegistrationInputTarget) {
      // Read the document as soon as it is chosen, so the fields below are filled
      // in before the user starts typing them. It uploads to S3 on the way, which
      // is why the generic presign path is not used for this input.
      this.businessRegistrationInputTarget.addEventListener('change', (e) =>
        this._prefillFromDocument(e.target),
      )
    }

    if (this.hasBusinessProfileInputTarget) {
      this.businessProfileInputTarget.addEventListener('change', (e) => {
        generatePresignedUrl('business_profiles/', e.target)
      })
    }

    if (this.hasDirectorUtilityBillInputTarget) {
      this.directorUtilityBillInputTarget.addEventListener('change', (e) => {
        generatePresignedUrl('kyc_proofs/', e.target)
      })
    }
  }

  _prefillFromDocument(input) {
    if (!this.parseUrlValue) {
      generatePresignedUrl('business_registrations/', input)
      return
    }

    runPrefill({
      input,
      form: this.kycFormTarget,
      parseUrl: this.parseUrlValue,
      statusEl: this.hasParseStatusTarget ? this.parseStatusTarget : null,
      documentName: this.documentNameValue,
      dateFormat: 'dmy',
      messages: this.parseMessagesValue,
    })
  }

  _loadPhoneInput() {
    if (this.iti) return
    if (!this.hasPhoneInputTarget) return
    this.iti = loadPhoneInput(
      this.phoneInputTarget,
      this.data.get('country'),
      this.errorMsgTarget,
      this.validMsgTarget
    )
  }

  _validateInput() {
    if (!this.hasPhoneInputTarget) return true
    return validateInput(
      this.iti,
      this.phoneInputTarget,
      this.errorMsgTarget,
      this.validMsgTarget
    )
  }


  _handleFileUploadSize() {
    document.querySelectorAll('input[type=file]').forEach((fileInput) => {
      fileInput.addEventListener('change', function () {
        const selectedFile = fileInput.files[0]
        if (!selectedFile) return

        const fileSize = selectedFile.size // in bytes
        const maxSize = 25 * 1024 * 1024 // 25MB in bytes

        if (fileSize >= maxSize) {
          alert(
            'File size exceeds the maximum allowed size of 25MB. Please select a smaller file.',
          )

          fileInput.value = ''
        }
      })
    })
  }

  submitForm(e) {
    const self = this
    const form = self.kycFormTarget

    var isValid = self._validateInput()
    if (!isValid) {
      e.preventDefault()
      return
    }

    if (areAllFilesUploaded(form)) {
      return
    }

    e.preventDefault()
    form.submit.disabled = true

    uploadFileInForm(form, () => {
      form.submit.disabled = false
      form.submit.click()
    })
  }
}
